export default {
      id: "compass-usage",
      viewBox: "0 0 18.345 60.558",
      url: __webpack_public_path__ + "live-atlas/img/icons.e641665a.svg#compass",
      toString: function () {
        return this.url;
      }
    }